<section class="tabs">
  <ul>
    <li [ngClass]="{'active': pestanaActiva === 1}" (click)="datosUsuario()"> {{'usuarios.general.modal.titulo' |
      translate}}</li>
    <!-- <li *ngIf="usuario" [ngClass]="{'active': pestanaActiva === 2}" (click)="permisosUsuario()">Relación de Permisos</li> -->
  </ul>
  <content>
    <form *ngIf="pestanaActiva === 1" [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
      <div class="info">{{'global.infoRequired' | translate}}</div>
      <div class="entry-4-modal">
        <label>{{'usuarios.general.modal.userName' | translate}} *</label>
        <input id="userName" type="email" autocomplete="off" formControlName="userName">
      </div>
      <div class="entry-4-modal" *ngIf="showPassword">
        <label *ngIf="!usuarioId">{{'usuarios.general.modal.password' | translate}} *</label>
        <label *ngIf="usuarioId">{{'usuarios.general.modal.newPassword' | translate}}</label>
        <input type="text" formControlName="password">
      </div>
      <div class="entry-4-modal" *ngIf="!this.usuarioId">
        <label>{{'usuarios.general.modal.rol' | translate}} *</label>
        <app-filterable-list class="short-list" [itemsList]="rolesUsuarios" [selectedItem]="newEditForm.get('rol')"
          [placeHolder]="false"></app-filterable-list>
      </div>
      <div class="entry-4-modal">
        <label>{{'usuarios.general.modal.nombre' | translate}} *</label>
        <input type="text" formControlName="nombre">
      </div>
      <div class="entry-4-modal">
        <label>{{'usuarios.general.modal.apellido' | translate}} *</label>
        <input type="text" formControlName="apellido">
      </div>
      <div class="entry-4-modal">
        <label>{{'usuarios.general.modal.idioma' | translate}} *</label>
        <app-filterable-list class="short-list" [itemsList]="idiomas" [selectedItem]="newEditForm.get('idioma')"
          [placeHolder]="false" [disabled]="disabledIdioma"></app-filterable-list>
      </div>
      <div class="entry-4-modal">
        <label>{{'usuarios.general.modal.telefono' | translate}}</label>
        <input type="text" formControlName="phoneNumber">
      </div>
      <div class="entry-4-modal alignment-start">
        <input type="checkbox" id="editHabilitado" formControlName="habilitado">
        <label for="editHabilitado">{{'usuarios.general.modal.habilitado' | translate}}</label>
      </div>
      <div class="entry-4-modal alignment-start">
        <input type="checkbox" id="dobleFactor" formControlName="dobleFactor">
        <label for="dobleFactor">{{'usuarios.general.modal.dobleFactor' | translate}}</label>
      </div>
      <div class="entry-4-modal alignment-start" *ngIf="usuarioId">
        <input type="checkbox" id="bloqueo" formControlName="bloqueo">
        <label for="bloqueo">{{'usuarios.general.modal.bloqueo' | translate}}<i class="fas fa-info-circle" style="margin-left: .3em"
            title="{{'usuarios.general.infoBloqueo' | translate}}"></i></label>
      </div>
    </form>
    <!-- <mat-tree *ngIf="pestanaActiva === 2 && (usuario || !usuarioId)" [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
      <div></div>
      <mat-checkbox class="checklist-leaf-node"
                      [checked]="checklistSelection.isSelected(node)"
                      (change)="todoLeafItemSelectionToggle(node)">{{node.item}}</mat-checkbox>
      </mat-tree-node>

      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
      <div matTreeNodeToggle>
          <i [ngClass]="treeControl.isExpanded(node) ? 'fas fa-angle-down' : 'fas fa-angle-right'" title="{{' Toggle ' + node.item}}"></i>
      </div>
      <mat-checkbox [checked]="descendantsAllSelected(node)"
                      [indeterminate]="descendantsPartiallySelected(node)"
                      (change)="itemSelectionToggle(node)">{{node.item}}</mat-checkbox>
      </mat-tree-node>
  </mat-tree> -->
  </content>
</section>
<footer class="button-bar-right">
  <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
  <button (click)="save()">{{usuarioId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>